import { render, staticRenderFns } from "./CurrencyHistory.vue?vue&type=template&id=6341ca71&scoped=true"
import script from "./CurrencyHistory.vue?vue&type=script&lang=js"
export * from "./CurrencyHistory.vue?vue&type=script&lang=js"
import style0 from "./CurrencyHistory.vue?vue&type=style&index=0&id=6341ca71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6341ca71",
  null
  
)

export default component.exports